import React from 'react'
import { Field, reduxForm } from 'redux-form'
import Modal from '../../elements/ModalBlue'
import Button from '../../elements/Button'
import TextInput from 'app/elements/TextInput'

import { utils } from 'alelo-logic'

import { Wrapper, Title, Text, WrapperButton, Form } from './styles'

import image from '../../../static/icon-veloe-background.svg'

const validate = values => {
  const errors = {}
  if (!values.email) {
    errors.email = 'Campo Obrigatório'
  }
}

const renderTextInput = ({ input, meta: { touched, error }, ...props }) => {
  return <TextInput type="text" {...input} {...props} errorMessage={touched && error} />
}

class EmailStatementModal extends React.Component {
  render() {
    const { handleClick, openModal, handleChangeEmail, valid, saving } = this.props
    return (
      <Modal backgroundImage={image} position="right bottom">
        <Wrapper>
          <Title>Download do extrato</Title>
          <Text />
          <Text>Informe o email para receber o link para fazer download do extrato.</Text>
          <Text />
          <Form>
            <Field
              name="email"
              lengthCounter
              placeholder="Digite Aqui"
              component={renderTextInput}
              label="E-mail"
              validate={[utils.emptyFieldValidate, utils.emailValidate]}
              onChange={evt => handleChangeEmail(evt)}
              isRequired
              negative
            />
          </Form>
          <WrapperButton>
            <Button
              disabled={!valid || saving}
              loading={saving}
              buttonType="darkBlue"
              text="Ok"
              onClick={() => handleClick()}
              type="button"
            />

            <Button
              buttonType="white"
              text="Cancelar"
              onClick={() => openModal(false, null)}
              type="button"
            />
          </WrapperButton>
        </Wrapper>
      </Modal>
    )
  }
}

export default reduxForm({
  form: 'EmailStatementModal',
  validate
})(EmailStatementModal)



// WEBPACK FOOTER //
// ./src/app/modules/EmailStatementModal/index.js